/* ═══════════════════════════════════════════════════════════════════════════
   whatsapp_widget.js  —  floating WhatsApp chat button for every website page

   Architecture mirrors a11y.js / animations.js: loads via web_include_js,
   reads its config from a <head> schema and self-mounts with zero markup
   changes to any page template.

   SCHEMA (set in <head> via Website HQ Settings -> WhatsApp Chat Widget):
     window.WhatsAppSchema = {
       enabled:  true,
       number:   '919899258043',   // digits only, country code, no '+'
       message:  'Hi! I have a question about your products.',
       position: 'Bottom Right' | 'Bottom Left',
       style:    '' | 'Quiet',         // Quiet: a smaller button on the page surface, ringed in the theme's accent
     }

   OPT-OUT:
     data-no-whatsapp on <body>     skip entire widget for this page
   ═══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var schema = window.WhatsAppSchema || {};
  if (!schema.enabled || !schema.number) return;

  var SKIP_PATHS = [
    '/login', '/register', '/update-password', '/complete-signup',
    '/forgot', '/verify', '/qrcode', '/printview', '/printpreview',
  ];

  var ICON =
    '<svg viewBox="0 0 24 24" width="28" height="28" fill="#fff" aria-hidden="true">' +
      '<path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.84.5 3.56 1.45 5.04L2 22l5.25-1.38a9.85 9.85 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.04c-.24.69-1.4 1.32-1.93 1.4-.5.08-1.12.11-1.81-.11-.42-.13-.95-.3-1.64-.6-2.88-1.24-4.76-4.13-4.9-4.32-.14-.19-1.18-1.57-1.18-3 0-1.42.74-2.12 1.01-2.41.27-.29.58-.36.78-.36l.56.01c.18.01.42-.07.66.5.24.58.82 2 .89 2.15.07.15.12.33.02.53-.1.2-.16.32-.31.49-.15.17-.31.38-.45.51-.15.14-.3.3-.13.59.17.29.76 1.25 1.63 2.02 1.12 1 2.07 1.31 2.36 1.46.29.15.46.13.63-.05.17-.18.74-.86.93-1.16.2-.29.4-.24.66-.15.27.1 1.69.8 1.98.95.29.14.48.21.55.34.07.13.07.74-.17 1.43z"/>' +
    '</svg>';

  function buildHref() {
    var url = 'https://wa.me/' + schema.number.replace(/\D/g, '');
    if (schema.message) url += '?text=' + encodeURIComponent(schema.message);
    return url;
  }

  function mount() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (SKIP_PATHS.indexOf(path) !== -1) return;
    if (document.body.hasAttribute('data-no-whatsapp')) return;
    if (document.querySelector('.wa-fab')) return;
    // The PWA shell (raftor_pwahq) puts this same contact link inside its own
    // drawer instead -- a second floating button stacked over its bottom nav
    // adds nothing. Checking data-pwahq alone isn't reliable here: this
    // script (websitehq.bundle.js) loads as a plain synchronous <script>
    // positioned well after pwahq_boot.js's own <script defer>, so by the
    // time this file's queued DOMContentLoaded callback actually runs,
    // pwahq_boot.js has typically already finished activateShell() (its
    // config read is synchronous, resolving as a microtask ahead of the
    // DOMContentLoaded task) and already cleared data-pwahq -- found live,
    // the FAB was still mounting under the shell despite that check.
    // body.pwahq-active is the one signal activateShell() sets and never
    // clears, so it stays valid for the rest of the page's life either way.
    if (document.documentElement.hasAttribute('data-pwahq')) return;
    if (document.body.classList.contains('pwahq-active')) return;

    var posClass = schema.position === 'Bottom Left' ? 'wa-fab--left' : 'wa-fab--right';

    var link = document.createElement('a');
    link.className = 'wa-fab ' + posClass + (schema.style === 'Quiet' ? ' wa-fab--quiet' : '');
    link.href = buildHref();
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', 'Chat with us on WhatsApp');
    link.innerHTML = ICON;

    document.body.appendChild(link);
    document.body.classList.add('wa-fab-present');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

}());
